import ReportTable from '../../../../../components/Grid/ReportTable';

export default function GeralTable(props: any) {
  return <ReportTable model={props.model} columnCount={8} />;
}
